export interface EmergencyContactForm {
  name: string;
  phone: string;
  relationship: string;
}

export type EmergencyContactError = 'nameRequired' | 'phoneRequired' | 'phoneInvalid' | 'relationshipRequired';

export const EMPTY_EMERGENCY_CONTACT: EmergencyContactForm = {
  name: '',
  phone: '',
  relationship: '',
};

export function validateEmergencyContact(form: EmergencyContactForm): EmergencyContactError | null {
  if (!form.name.trim()) return 'nameRequired';
  if (!form.phone.trim()) return 'phoneRequired';
  if (!/^1[3-9]\d{9}$/.test(form.phone.trim())) return 'phoneInvalid';
  if (!form.relationship.trim()) return 'relationshipRequired';
  return null;
}

const PRESET_RELATIONSHIPS = new Set(['parent', 'relative', 'friend', 'other']);

export function normalizeEmergencyContact(form: EmergencyContactForm): EmergencyContactForm {
  const relationship = form.relationship.trim();
  return {
    name: form.name.trim(),
    phone: form.phone.trim(),
    relationship: PRESET_RELATIONSHIPS.has(relationship) ? relationship : 'other',
  };
}
